import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-xl mb-2xl mt-4xl@lg mb-6xl@lg text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockTitle = _resolveComponent("BlockTitle")!
  const _component_PosterCardSkeleton = _resolveComponent("PosterCardSkeleton")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_PosterCard = _resolveComponent("PosterCard")!
  const _component_ButtonText = _resolveComponent("ButtonText")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Grid, { size: "lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_BlockTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trans("general.cinema_premieres")), 1)
          ]),
          _: 1
        }),
        (_ctx.requestState.status === 'loading')
          ? (_openBlock(), _createBlock(_component_Row, {
              key: 0,
              gap: "lg"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                  return _createVNode(_component_Col, {
                    key: 'poster-card-skeleton-' + n,
                    size: ['1/2', '1/3@sm', '1/4@md']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PosterCardSkeleton)
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.requestState.status === 'ready')
          ? (_openBlock(), _createBlock(_component_Row, {
              key: 1,
              gap: "lg"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cineMedias, (media) => {
                  return (_openBlock(), _createBlock(_component_Col, {
                    key: media._id,
                    size: ['1/2', '1/3@sm', '1/4@md']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PosterCard, { media: media }, null, 8, ["media"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Button, {
            to: { name: 'CineMedias' },
            style: {"text-decoration":"none"},
            color: "accent",
            isText: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonText, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.trans("general.see_all_cinema_premieres")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ButtonIcon, { name: "chevron-right" })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}